import UserDashView from "./UserDashView";

function UserDashboard() {
  return (
    <>
      <UserDashView />
    </>
  );
}

export default UserDashboard;
